const parseUrl = (str) => {
  const re = /(\?|\&)([^=]+)\=([^&]+)/g
  let match
  let result = []
  while(match = re.exec(str)) {
    result.push(match[3])
  }
  return result
}

export default parseUrl


// WEBPACK FOOTER //
// ./src/lib/parseurl.js